import { useEffect, useState, useRef } from "react";
import { Col, Row, Overlay, Button, Popover } from "react-bootstrap";
import { connect } from "react-redux";
import { Formik, Form } from "formik";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import FormikControl from "../../../layouts/Input/FormikControl";
import storage from "../../../apis/Storage";
import {
  GET_DISTRIBUTOR_DDL,
  GET_ADDJOB_DISTRIBUTIONCENTER_DDL,
  GET_CITIES,
  GET_RSO_USERS,
} from "../../../Types";
import {
  formatDate,
  renderCell,
  renderHeader,
  toCommaSeparated,
} from "../../../utilities/FUNCTIONS";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import { Link } from "react-router-dom";
import {
  getVfoPerformanceReport,
  downloadJob,
} from "./VfoPerformanceReportActions";
import { getDropdownList,getDropdownListByPost } from "../../Shared/dropdownListActions";
import { useHistory } from "react-router-dom";

const VfoPerformanceReport = (props) => {
  const userRights = JSON.parse(storage.get("_userRights"));
  const [target, setTarget] = useState(null);
  const [show, setShow] = useState(false);
  const ref = useRef(null);
  // pagination states
  const [currentIndex, setCurrentIndex] = useState();
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [distributorList, setDistributorList] = useState([]);
  const [distCenterList, setdistCenterList] = useState([]);
  const [deliveryManNameList, setDeliveryManNameList] = useState([]);
  const [deliveryManTillNoList, setDeliveryManTillNoList] = useState([]);
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [filterDistributorName, setFilterDistributorName] = useState([]);
  const [filterDistributionID, setFilterDistributionID] = useState([]);
  const [filterCity, setFilterCity] = useState(null);
  const [filterRSO, setFilterRSO] = useState(null);

  const [filter, setfilter] = useState({
    distributor: null,
    distCenter: null,
    city: null,
    vfoName: null,
    fromDate: new Date(),
    toDate: new Date(),
    pageNo: 0,
    searchText: null,
  });

  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  function commonReset(reset = true) {
    if (reset) {
      setfilter({
        distributor:
          userRights != null && userRights?.userType == "DistributorUser"
            ? filter.distributor
            : null,
        distCenter: null,
        city: null,
        vfoName: null,
        fromDate: new Date(),
        toDate: new Date(),
        pageNo: 0,
        searchText: null,
      });
      setFilterDistributorName(null);
      setFilterDistributionID(null);
      setdistCenterList([]);
    }
  }

  function formRequestObject() {
    let requestData = {
      distributor:
        filterDistributorName?.length > 0
          ? toCommaSeparated(filterDistributorName)
          : null,

      distCenter:
        filterDistributionID?.length > 0
          ? toCommaSeparated(filterDistributionID)
          : null,

      city: filterCity?.value ?? null,
      rso: filterRSO?.value ?? null,
      fromDate: filter.fromDate ? formatDate(filter.fromDate) : null,
      toDate: filter.toDate ? formatDate(filter.toDate) : null,
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText,
    };

    if (
      userRights &&
      (userRights?.userType === "DistributorUser" ||
        userRights?.userType === "CoreAppUser")
    ) {
      requestData.distributorId = userRights?.distributorId;
    }

    return requestData;
  }
  function fetchReportData(request) {
    const finalRequest = request == null ? formRequestObject() : request;
    props.getVfoPerformanceReport(finalRequest);
  }

  const handleResetFilters = (resetForm) => {
    resetForm();
    commonReset();
  };

  const getData = (page) => {
    setCurrentPageNo(page);
    var request = { ...formRequestObject(), pageNo: page };
    fetchReportData(request);
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);
    var request = { ...formRequestObject(), pageSize: pageSize };
    fetchReportData(request);
  };

  const searchChanged = (text) => {
    setSearchText(text);
  };

  const LoadDataByfilter = (event) => {
    setCurrentPageNo(0);
    var request = { ...formRequestObject(), pageNo: 0 };
    fetchReportData(request);
    setShow(false);
    setIsApplyFilter(true);
  };

  const Download = () => {
    let request = formRequestObject();
    request.isExport = true;
    props.downloadJob(request);
  };

  useEffect(() => {
    setCurrentPageNo(0);
    fetchReportData();
  }, [searchText]);

  useEffect(() => {
    if (props.report && props.report.totalRecords > 0) {
      setTotalRecords(props.report.totalRecords);
    } else {
      setTotalRecords(0);
    }
  }, [props.report]);

  useEffect(() => {
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL,
    );
    props.getDropdownList(`api/City`, GET_CITIES);
    props.getDropdownList(`api/User/GetRSODDL`, GET_RSO_USERS);
  }, []);

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distributorList = props.allDistributorList.filter(
        (x) => x.value == userRights?.distributorId,
      );
      if (distributorList?.length > 0) {
        setfilter({
          ...filter,
          distributor: {
            label: distributorList[0]?.label,
            value: distributorList[0]?.value,
          },
        });
      }
      setDistributorList(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    } else if (userRights != null && userRights?.userType == "CoreAppUser") {
      let distributorList = props.allDistributorList.filter((x) =>
        userRights?.distributorId.includes(x.value),
      );
      setDistributorList(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    } else {
      setDistributorList(
        props.allDistributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    }
  }, [props.allDistributorList]);

  useEffect(() => {
    if (
      userRights != null &&
      (userRights?.userType == "DistributorUser" ||
        userRights?.userType == "CoreAppUser")
    ) {
      let distCenterList = props.selectedAddJobDistCentersList.filter((x) =>
        userRights?.distCenterIds.includes(x.value),
      );
      setdistCenterList(
        distCenterList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    } else {
      setdistCenterList(
        props.selectedAddJobDistCentersList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    }
  }, [props.selectedAddJobDistCentersList]);

  useEffect(() => {
    if (filterDistributorName?.length > 0) {
       props.getDropdownListByPost(
                  `api/DistCenter/GetDistCentersDDL`,
                  { distributorIds: toCommaSeparated(filterDistributorName) },
                  GET_ADDJOB_DISTRIBUTIONCENTER_DDL
              );
    } else {
      setFilterDistributionID([]);
    }
  }, [filterDistributorName]);

  const columns = [
    {
      Header: "Distributor",
      accessor: "distributorName",
    },
    {
      Header: "Dist Center",
      accessor: "distCenterName",
    },
    {
      Header: "City",
      accessor: "city",
    },
    {
      Header: renderHeader("Total Jobs"),
      accessor: "totalJobs",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("Inducted Shops"),
      accessor: "inductedShops",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("Sign Up"),
      accessor: "signUp",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: "Vfo Name",
      accessor: "vfoName",
    },
    {
      Header: "Progress",
      id: "Progress",
      Cell: (props) => {
        const total = Number(props.row.original.totalJobs || 0);
        const inducted = Number(props.row.original.inductedShops || 0);
        const signUp = Number(props.row.original.signUp || 0);

        const signUpPercent = total > 0 ? (signUp / total) * 100 : 0;
        const inductedPercent = total > 0 ? (inducted / total) * 100 : 0;
        const remainingPercent = 100 - inductedPercent;

        return (
          <div style={{ width: "106px" }}>
            <div className="progress mt-2" style={{ height: "12px" }}>
              {/* 🔵 SignUp (Blue) */}
              <div
                className="progress-bar bg-info progress-bar-striped"
                role="progressbar"
                style={{ width: `${signUpPercent}%` }}
              >
                {signUp}
              </div>

              {/* 🟢 Inducted (Green minus signup if signup is subset) */}
              <div
                className="progress-bar bg-success progress-bar-striped"
                role="progressbar"
                style={{
                  width: `${Math.max(inductedPercent - signUpPercent, 0)}%`,
                }}
              >
                {inducted}
              </div>

              {/* ⚪ Remaining */}
              <div
                className="progress-bar bg-light progress-bar-striped rounded"
                role="progressbar"
                style={{ width: `${remainingPercent}%` }}
              >
                {total}
              </div>
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div>
      <VzPageContainer title="Vfo Performance Report">
        <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>Vfo Performance Report</b>
            </h4>
            <br />
          </Col>
        </Row>
        <Row>
          <Col md={10} style={{ float: "right" }}>
            <div ref={ref}>
              <Button
                onClick={openFilterModal}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-filter" />
                Filters
              </Button>

              <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
                width="430px"
                style={{ width: "430px" }}
              >
                <Popover
                  id="popover-contained"
                  style={{ maxWidth: "360px", width: "360px" }}
                >
                  <Popover.Header as="h3">Filters</Popover.Header>
                  <Popover.Body>
                    <Formik
                      enableReinitialize
                      initialValues={filter}
                      validator={() => ({})}
                      onSubmit={LoadDataByfilter}
                    >
                      {(formik) => (
                        <Form autoComplete="off">
                          <Row>
                            {(userRights == null ||
                              userRights?.userType == "CoreAppUser") && (
                              <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="react-select"
                                  label="Distributor"
                                  name="distributor"
                                  options={distributorList}
                                  isSearchable={true}
                                  isMulti={true}
                                  handleOnChange={(selected) => {
                                    setFilterDistributorName(selected || []);
                                    setFilterDistributionID([]); // reset dependent dropdown
                                  }}
                                  value={filterDistributorName}
                                />
                              </Col>
                            )}

                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Distribution Center"
                                name="distCenter"
                                options={distCenterList}
                                isSearchable={true}
                                isMulti={true}
                                handleOnChange={(selected) => {
                                  setFilterDistributionID(selected || []);
                                }}
                                value={filterDistributionID}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="City"
                                name="city"
                                options={props.cities}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    return;
                                  }
                                  setFilterCity({
                                    label: e.label,
                                    value: e.value,
                                  });
                                }}
                                value={filterCity}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="RSO"
                                name="rso"
                                options={props.rsoUsers}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    return;
                                  }
                                  setFilterRSO({
                                    label: e.label,
                                    value: e.value,
                                  });
                                }}
                                value={filterRSO}
                              />
                            </Col>
                            <Row style={{ paddingRight: 0 }}>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  formik={formik}
                                  type="fromDate"
                                  control="date"
                                  label="From Date"
                                  name="fromDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, fromDate: value });
                                  }}
                                  value={filter.fromDate}
                                />
                              </Col>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  formik={formik}
                                  control="date"
                                  type="toDate"
                                  label="To Date"
                                  name="toDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, toDate: value });
                                  }}
                                  value={filter.toDate}
                                />
                              </Col>
                            </Row>
                          </Row>
                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group">
                              <Link
                                onClick={handleResetFilters.bind(
                                  null,
                                  formik.resetForm,
                                  setIsApplyFilter(false),
                                )}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "left",
                                }}
                              >
                                Reset
                              </Link>
                              <Link
                                onClick={() => {
                                  setShow(false);
                                  setTarget(null);
                                  commonReset(isApplyFilter);
                                }}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "right",
                                }}
                              >
                                Cancel
                              </Link>
                              <div className="float-right">
                                <Button
                                  type="submit"
                                  className="btn btn-primary"
                                  style={{
                                    marginRight: "10px",
                                    float: "right",
                                  }}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </div>
          </Col>
          <Col md={2} style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={Download}
              className="m-3"
              variant="outline-primary"
            >
              <i className="fa fa-download me-1" />
              Export
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <ServerSideDataTable
              data={props.report?.data ?? []}
              columns={columns}
              getTrProps={(event, data) => null}
              goToPreviousPage={(val) => getData(val)}
              goToNextPage={(val) => getData(val)}
              totalRecords={totalRecords}
              pageSizeChange={(size) => pageSizeChanged(size)}
              myPageSize={currentPageSize}
              myIndex={currentIndex}
              pageNo={currentPageNo}
              searchChanged={searchChanged}
            />
          </Col>
        </Row>
      </VzPageContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    report: state.VfoPerformanceReport,
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],
    selectedAddJobDistCentersList: state.ddlList.selectedAddJobDistCentersList
      ? state.ddlList.selectedAddJobDistCentersList
      : [],
    cities: state.ddlList.cities ? state.ddlList.cities : [],
    rsoUsers: state.ddlList.rsoUsers ? state.ddlList.rsoUsers : [],
  };
};
export default connect(mapStateToProps, {
  getVfoPerformanceReport,
  getDropdownList,
  getDropdownListByPost,
  downloadJob,
})(VfoPerformanceReport);
